import moment from "moment-timezone";
import type { Action } from "../actions.types";

/**
 * Check if an action is disabled based on its date window.
 * An action is disabled if current time is before available_date or after closed_date.
 */
export function isActionDisabledByDate(action: Action): boolean {
  const now = moment();
  const isBeforeAvailable =
    action.available_date && now.isBefore(moment(action.available_date));
  const isAfterClosed =
    action.closed_date && now.isAfter(moment(action.closed_date));

  return Boolean(isBeforeAvailable || isAfterClosed);
}
